import { render, staticRenderFns } from "./UserLink.vue?vue&type=template&id=aca13be0&"
import script from "./UserLink.vue?vue&type=script&lang=js&"
export * from "./UserLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports